import React, { useEffect, useState } from "react";
import styles from "../../style";
import { jctech } from "../../assets";
import { socialMedia } from "../../constants";

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => setIsVisible(true), []);
  const year = new Date().getFullYear();

  return (
    <footer className={`relative w-full overflow-hidden bg-gradient-to-b from-white to-gray-50 ${styles.paddingY}`}>
      {/* Ambient gradient blobs */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-48 -top-40 h-[420px] w-[420px] rounded-full bg-blue-400/15 blur-3xl animate-pulse" />
        <div className="absolute -right-48 bottom-0 h-[520px] w-[520px] rounded-full bg-emerald-400/15 blur-3xl animate-pulse delay-700" />
      </div>

      {/* Main container */}
      <div className="relative z-10 container mx-auto px-4">
        <div
          className={`rounded-3xl border border-gray-200/70 bg-white/70 backdrop-blur-sm shadow-xl transition-all duration-700 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"
          }`}
        >
          {/* Brand & CTA */}
          <div className="flex flex-col items-center text-center p-10">
            <img
              src={jctech}
              alt="JC-Techs"
              className="h-[72px] w-auto object-contain"
              loading="lazy"
            />
            <p className="mt-4 max-w-md text-sm text-gray-600">
              A Next Generation of Street Infrastructure Management
            </p>
          </div>

          {/* Divider */}
          <div className="border-t border-gray-200/80" />

          {/* Bottom bar */}
          <div className="flex flex-col items-center justify-between gap-4 px-8 py-6 sm:flex-row">
            <p className="text-sm text-gray-600 text-center">
              © {year} JC-TECHS. All rights reserved.
            </p>

            <div className="flex items-center gap-4">
              {socialMedia.map((s) => (
                <a
                  key={s.id}
                  href={s.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.id}
                  className="group inline-flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white/80 backdrop-blur-sm shadow-sm transition-all hover:-translate-y-0.5 hover:shadow-md"
                >
                  <img
                    src={s.icon}
                    alt=""
                    aria-hidden="true"
                    className="h-4 w-4 grayscale opacity-80 transition-all group-hover:grayscale-0 group-hover:opacity-100"
                    loading="lazy"
                  />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Optional tagline */}
        <div className="mt-4 text-center text-xs text-gray-500">
          Empowering smart mobility through AI-powered street intelligence.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
